document.addEventListener('DOMContentLoaded', function() {
  const sections = document.querySelectorAll('[data-section-type="product"]');
  
  sections.forEach(section => {
    initFeaturedOffer(section);
  });
});

function initFeaturedOffer(section) {
  if (!section) return;

  // Initialize all features
  initVariantSelector(section);
  initThumbnailSlider(section);
  initMainImageSwipe(section);
  initCollapsibles(section);
}

// Variant Option Functionality
function initVariantSelector(section) {
  const variantButtons = section.querySelectorAll('[data-ck-variant-option]');
  const ctaButton = section.querySelector('[data-ck-cta-button]');
  const freebieItems = section.querySelectorAll('[data-freebie-tier]');
  const priceDisplay = section.querySelector('[data-ck-variant-price]');
  const comparePriceDisplay = section.querySelector('[data-ck-variant-compare-price]');

  function updateFreebies(selectedVariantTier) {
    freebieItems.forEach(freebie => {
      const freebieUnlockTier = parseInt(freebie.getAttribute('data-freebie-tier')) || 1;
      const mainImage = freebie.querySelector('[data-freebie-main-image]');
      const defaultIcon = freebie.querySelector('[data-freebie-default-icon]');
      
      if (mainImage && defaultIcon) {
        if (selectedVariantTier >= freebieUnlockTier) {
          mainImage.classList.remove('hidden');
          defaultIcon.classList.add('hidden');
        } else {
          mainImage.classList.add('hidden');
          defaultIcon.classList.remove('hidden');
        }
      }
    });
  }

  function updatePrice(priceText, comparePriceText) {
    if (priceDisplay) {
      priceDisplay.textContent = priceText || '';
    }
    
    if (comparePriceDisplay) {
      if (comparePriceText) {
        comparePriceDisplay.textContent = comparePriceText;
        comparePriceDisplay.classList.remove('hidden');
      } else {
        comparePriceDisplay.textContent = '';
        comparePriceDisplay.classList.add('hidden');
      }
    }
  }

  if (variantButtons.length && ctaButton) {
    variantButtons.forEach(button => {
      button.addEventListener('click', function() {
        variantButtons.forEach(btn => btn.classList.remove('selected'));
        this.classList.add('selected');
        
        const variantLink = this.getAttribute('data-variant-link');
        const variantPrice = this.getAttribute('data-variant-price');
        const variantComparePrice = this.getAttribute('data-variant-compare-price');
        
        if (variantLink) {
          ctaButton.setAttribute('href', variantLink);
        }

        updatePrice(variantPrice, variantComparePrice);

        const variantTier = parseInt(this.getAttribute('data-variant-tier')) || 1;
        updateFreebies(variantTier);
      });
    });

    // Initialize on page load with selected variant (preselected or first)
    const selectedVariant = section.querySelector('[data-ck-variant-option].selected') || variantButtons[0];
    if (selectedVariant) {
      const selectedVariantTier = parseInt(selectedVariant.getAttribute('data-variant-tier')) || 1;
      const selectedPrice = selectedVariant.getAttribute('data-variant-price');
      const selectedComparePrice = selectedVariant.getAttribute('data-variant-compare-price');
      
      updateFreebies(selectedVariantTier);
      updatePrice(selectedPrice, selectedComparePrice);
    }
  }
}

// Thumbnail Slider with Drag Functionality
function initThumbnailSlider(section) {
  const thumbnailSlider = section.querySelector('[data-ck-thumbnail-slider]');
  if (!thumbnailSlider) return;

  const prevButton = thumbnailSlider.querySelector('[data-ck-thumbnail-prev]');
  const nextButton = thumbnailSlider.querySelector('[data-ck-thumbnail-next]');
  const thumbnailTrack = thumbnailSlider.querySelector('[data-ck-thumbnail-track]');
  const thumbnailList = thumbnailSlider.querySelector('[data-ck-thumbnail-list]');
  const thumbnailItems = thumbnailSlider.querySelectorAll('[data-ck-thumbnail-item]');
  const mediaItems = section.querySelectorAll('[data-product-media-wrapper]');

  if (!thumbnailItems.length) return;

  let currentIndex = 0;
  const visibleThumbnails = window.innerWidth <= 768 ? 4 : 5;
  const maxIndex = Math.max(0, thumbnailItems.length - visibleThumbnails);

  // Drag functionality
  let isDragging = false;
  let startX = 0;
  let scrollLeft = 0;

  thumbnailTrack.addEventListener('mousedown', (e) => {
    isDragging = true;
    thumbnailTrack.style.cursor = 'grabbing';
    startX = e.pageX - thumbnailTrack.offsetLeft;
    scrollLeft = thumbnailTrack.scrollLeft;
  });

  thumbnailTrack.addEventListener('mouseleave', () => {
    isDragging = false;
    thumbnailTrack.style.cursor = 'grab';
  });

  thumbnailTrack.addEventListener('mouseup', () => {
    isDragging = false;
    thumbnailTrack.style.cursor = 'grab';
  });

  thumbnailTrack.addEventListener('mousemove', (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - thumbnailTrack.offsetLeft;
    const walk = (x - startX) * 2;
    thumbnailTrack.scrollLeft = scrollLeft - walk;
  });

  // Touch drag for mobile
  let touchStartX = 0;
  let touchScrollLeft = 0;

  thumbnailTrack.addEventListener('touchstart', (e) => {
    touchStartX = e.touches[0].pageX - thumbnailTrack.offsetLeft;
    touchScrollLeft = thumbnailTrack.scrollLeft;
  });

  thumbnailTrack.addEventListener('touchmove', (e) => {
    const x = e.touches[0].pageX - thumbnailTrack.offsetLeft;
    const walk = (x - touchStartX) * 2;
    thumbnailTrack.scrollLeft = touchScrollLeft - walk;
  });

  thumbnailTrack.style.cursor = 'grab';
  thumbnailTrack.style.overflowX = 'auto';
  thumbnailTrack.style.scrollBehavior = 'smooth';

  function updateSlider() {
    const itemWidth = thumbnailItems[0].offsetWidth;
    const gap = 8;
    const offset = currentIndex * (itemWidth + gap);
    thumbnailList.style.transform = `translateX(-${offset}px)`;

    prevButton.disabled = currentIndex === 0;
    nextButton.disabled = currentIndex >= maxIndex;
  }

  function switchMedia(mediaId) {
    mediaItems.forEach(item => item.classList.add('hidden'));
    
    const targetMedia = section.querySelector(`[data-media-item-id="${mediaId}"]`);
    if (targetMedia) {
      targetMedia.classList.remove('hidden');
    }

    thumbnailItems.forEach(item => item.classList.remove('active'));
    const activeThumbnail = thumbnailSlider.querySelector(`[data-media-id="${mediaId}"]`);
    if (activeThumbnail) {
      activeThumbnail.classList.add('active');
    }
  }

  // Thumbnail click handlers
  thumbnailItems.forEach((item, index) => {
    item.addEventListener('click', function(e) {
      // Prevent click if dragging
      if (Math.abs(thumbnailTrack.scrollLeft - scrollLeft) > 5) {
        e.preventDefault();
        return;
      }
      
      const mediaId = this.getAttribute('data-media-id');
      switchMedia(mediaId);
    });
  });

  // Arrow button handlers
  prevButton.addEventListener('click', function() {
    if (currentIndex > 0) {
      currentIndex--;
      updateSlider();
    }
  });

  nextButton.addEventListener('click', function() {
    if (currentIndex < maxIndex) {
      currentIndex++;
      updateSlider();
    }
  });

  updateSlider();
}

// Main Image Swipe Functionality
function initMainImageSwipe(section) {
  const mediaContainer = section.querySelector('.product__media');
  const mediaItems = Array.from(section.querySelectorAll('[data-product-media-wrapper]'));
  const thumbnailItems = section.querySelectorAll('[data-ck-thumbnail-item]');
  
  if (!mediaContainer || mediaItems.length <= 1) return;

  let touchStartX = 0;
  let touchEndX = 0;
  let currentMediaIndex = 0;

  // Find current active media
  mediaItems.forEach((item, index) => {
    if (!item.classList.contains('hidden')) {
      currentMediaIndex = index;
    }
  });

  function handleSwipe() {
    const swipeThreshold = 50;
    const diff = touchStartX - touchEndX;

    if (Math.abs(diff) > swipeThreshold) {
      if (diff > 0) {
        // Swiped left - show next
        showNextMedia();
      } else {
        // Swiped right - show previous
        showPreviousMedia();
      }
    }
  }

  function showNextMedia() {
    if (currentMediaIndex < mediaItems.length - 1) {
      currentMediaIndex++;
      updateMedia();
    }
  }

  function showPreviousMedia() {
    if (currentMediaIndex > 0) {
      currentMediaIndex--;
      updateMedia();
    }
  }

  function updateMedia() {
    const currentMedia = mediaItems[currentMediaIndex];
    const mediaId = currentMedia.getAttribute('data-media-item-id');

    // Hide all media
    mediaItems.forEach(item => item.classList.add('hidden'));
    
    // Show current media
    currentMedia.classList.remove('hidden');

    // Update thumbnails
    thumbnailItems.forEach(item => item.classList.remove('active'));
    const activeThumbnail = section.querySelector(`[data-media-id="${mediaId}"]`);
    if (activeThumbnail) {
      activeThumbnail.classList.add('active');
    }
  }

  // Touch events
  mediaContainer.addEventListener('touchstart', (e) => {
    touchStartX = e.changedTouches[0].screenX;
  }, { passive: true });

  mediaContainer.addEventListener('touchend', (e) => {
    touchEndX = e.changedTouches[0].screenX;
    handleSwipe();
  }, { passive: true });

  // Mouse events for desktop
  let mouseStartX = 0;
  let mouseEndX = 0;
  let isMouseDown = false;

  mediaContainer.addEventListener('mousedown', (e) => {
    isMouseDown = true;
    mouseStartX = e.screenX;
    mediaContainer.style.cursor = 'grabbing';
  });

  mediaContainer.addEventListener('mouseup', (e) => {
    if (!isMouseDown) return;
    isMouseDown = false;
    mouseEndX = e.screenX;
    mediaContainer.style.cursor = 'grab';
    
    const diff = mouseStartX - mouseEndX;
    const swipeThreshold = 50;

    if (Math.abs(diff) > swipeThreshold) {
      if (diff > 0) {
        showNextMedia();
      } else {
        showPreviousMedia();
      }
    }
  });

  mediaContainer.addEventListener('mouseleave', () => {
    isMouseDown = false;
    mediaContainer.style.cursor = 'grab';
  });

  mediaContainer.style.cursor = 'grab';
  mediaContainer.style.userSelect = 'none';
}

// Collapsible Tabs Functionality
function initCollapsibles(section) {
  const collapsibles = section.querySelectorAll('[data-ck-collapsible]');
  
  collapsibles.forEach(collapsible => {
    const trigger = collapsible.querySelector('[data-ck-collapsible-trigger]');
    const content = collapsible.querySelector('[data-ck-collapsible-content]');
    
    if (trigger && content) {
      trigger.addEventListener('click', function() {
        const isOpen = collapsible.classList.contains('is-open');
        
        if (isOpen) {
          collapsible.classList.remove('is-open');
        } else {
          collapsible.classList.add('is-open');
        }
      });
    }
  });
}
